import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_TICKETS = "fetchCompanyTickets";

// mutation types
export const SET_COMPANY_TICKETS = "setCompanyTickets";
export const SET_COMPANY_TICKETS_PAGINATION = "setCompanyTicketsPagination";

const state = {
  companyTickets: [],
  companyTicketsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  companyTickets(state) {
    return state.companyTickets;
  },
  companyTicketsPagination(state) {
    return state.companyTicketsPagination;
  }
};

const actions = {
  [FETCH_COMPANY_TICKETS](context, payload) {
    let params = {
      page: context.state.companyTicketsPagination.currentPage,
      priority: payload.priority,
      status: payload.status,
      title: payload.title
    };
    return new Promise((resolve, reject) => {
      ApiService.query("company/tickets", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_TICKETS, data.data);
          context.commit(SET_COMPANY_TICKETS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_TICKETS](state, data) {
    state.companyTickets = data;
  },
  [SET_COMPANY_TICKETS_PAGINATION](state, data) {
    state.companyTicketsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
